import css from './DetallesRGPD.module.css'

const DetallesRGPD = ({ centro }) => (
  <div className={css.documento}>
    <div className={css.content}>
      <h3>Bienvenido a mundoestudiante</h3>
      <p>
        Queremos agradecerte que hayas confiado en nosotros para que te ayudemos con tus
        estudios, ¡Estamos seguros de que vas a notarlo en tus resultados desde el primer momento!
      </p>
      <p>
        Tanto el equipo completo de profesores de mundoestudiante, así como el personal de
        administración, estamos a tu disposición para solucionarte cualquier duda o inquietud. ¡No
        dudes en preguntarnos!
      </p>
      <p className={css.primary}>¡Somos encantadores!</p>
      <p>
        Nuestro horario de clase es de lunes a jueves de 10:00 a a 14:00 y de 16:30 a 20:30, viernes y
        sábado de 10:00 a 14:00. Infórmate, ya que podemos tener modicaciones de horario.
      </p>
      <p>
        Aprovechamos también para recordarte que puedes seguirnos en las redes sociales y en
        nuestro blog para estar al día de un montón de contenido muy interesante para estudiantes.
      </p>
      <p>
        En tu academia, nuestros compañeros te atenderán encantados. También puedes
        contactarnos teléfono o mandando un correo electrónico a: <span className={css.primary}>hola@mundoestudiante.com</span>
      </p>
      <p>Por último, te indicamos el extracto de las condiciones de la RGPD para tu información:</p>
      <p>
        Como usted sabe, el 25 de mayo de 2018 ha entrado en vigor el Reglamento General de Protección de Datos
        (RGPD). Se trata de una norma, de aplicación directa en toda la Unión Europea, relativa al tratamiento y
        protección de los datos personales de las personas físicas y a la libre circulación de estos datos.
      </p>
      <p>
        El RGPD ha sustituido la Ley Orágnica de Protección de Datos y al Reglamento RD-1720/2007, que la
        desarrolla.
      </p>
      <p>
        El RGPD incluye normas que redundan en una mayor protección de sus datos personales, incluyendo una
        total transparencia respecto a quién los trata, como y para qué.
      </p>
      <p>
        De acuerdo con el Reglamento (UE) 2016/679 del Parlamento y del Consejo de abril de 2016 y 
        la Ley Orgánica 3/2018, de 5 de diciembre de Protección de Datos Personales y Garantía de 
        los Derechos Digitales, {centro.sociedad.nombre}, como responsable del tratamiento de tus datos, te 
        informamos de que trataremos la información que nos proporciones con el propósito de gestionar 
        tu inscripción. 
      </p>
      <p>
        Tiene derecho a acceder, rectificar, oponerse, suprimir, solicitar la 
        portabilidad y limitar el tratamiento de sus datos personales, así como a presentar una 
        reclamación ante la AEPD. Para ejercer sus derechos, puede enviar un email 
        a: <strong>administracion@mundoestudiante.com</strong>. 
      </p>
      <p>
        Para obtener más información sobre el 
        tratamiento de sus datos y como ejercitar sus derechos visite la política de privacidad de 
        nuestra web, disponible en{' '}
        <a className={css.primary} target='_blank' href="https://www.mundoestudiante.com/politica-privacidad/" rel="noreferrer">https://www.mundoestudiante.com/politica-privacidad/</a>.
      </p>
    </div>
  </div>
)

export default DetallesRGPD